<div class="search-box">
  <pos-app-lib-customer-search (selectNewCustomer)="selectCustomer($event)" [disabled]="readonly"> </pos-app-lib-customer-search>
</div>
